import React from 'react'
import { Textarea } from '@/components/ui/textarea'

interface TextProps {
    questionId: string
    placeholder?: string
    value?: string
}

const Text: React.FC<TextProps> = ({
    questionId,
    placeholder = 'Enter your response...',
    value = '',
}) => {
    return (
        <div className="mt-4">
            <Textarea
                placeholder={placeholder}
                value={value}
                rows={4}
                style={{ maxHeight: '6em', overflow: 'auto' }}
                disabled
            />
        </div>
    )
}

export default Text
